export default {
  variants: {
    outline: {
      bg: "white",
    },
  },
};
